// extracted by mini-css-extract-plugin
export default {"sessionTime":"styles_sessionTime__3DfGx"};